export default function initAdvSearch()
{
    const form = document.getElementById('adv-search'),
        changeSearchBtn = document.getElementById('change-search'),
        dialog = form?.querySelector('dialog'),
        resultCount = form?.querySelector('.btn-info'),
        btnCountText = resultCount?.value.replace(/\d+/, '').trim(),
        noResultDOMCopy = form?.querySelector('.no-result').cloneNode(true),
        submitBtn = form?.querySelector('.btn[type="submit"]'),
        sorting = document.querySelector('.sorting.singleselect'),
        paging = document.querySelector('.pagination-area');

    if (form) {
        //initialize  dialog
        if (dialog && changeSearchBtn) {
            changeSearchBtn.addEventListener('click', () => {
                dialog.showModal();
            });
            //close dialog on click outside
            dialog.addEventListener('click', (e) => {
                if (e.target === dialog) {
                    dialog.close();
                }
            });
        }
        //enable tooltips
        const tooltips = form.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltips.forEach(tooltip => {
            new bootstrap.Tooltip(tooltip);
        });

        //get all input text fields
        const txtFields = form.querySelectorAll('input[type="text"]');
        txtFields.forEach(field => {
            initInputField(field);
        })

        //get all singleSelects
        const singleSelect = form.querySelectorAll('.singleselect');
        singleSelect.forEach(field => {
            initSingleSelects(field);
        })

        //get all multiSelects
        const multiSelects = form.querySelectorAll('.multiselect');
        multiSelects.forEach(field => {
            initMultiSelects(field);
        })

        //get besand checkbox
        const besand = form.querySelector('#besand');
        if (besand) {
            besand.addEventListener('change', (e) => {
                sendRequest();
            });
        }

        //form listen for reset event
        form.addEventListener('reset', (e) => {
            //wait for reset
            requestAnimationFrame(() => {
                sendRequest();
            });
        });

        // Fill out checkboxes
        if (prefill) {
            for (const [key, value] of Object.entries(prefill)) {
                let val = value;
                switch (key) {
                    case 'subject_and_condition':
                        if (val) {
                            document.getElementById('besand').checked = true;
                        }
                        break;
                    case 'sponsor':
                        document.querySelectorAll('button[name="sponsor-select"]').forEach(button => {
                            if (button.value == val) {
                                button.click();
                            }
                        });
                        break;
                    default:
                        val = value.split(',');
                        for (const v of val) {
                            const selector = `input[name="tx_hrksearch_advancedsearch[${key}name][]"]`;
                            document.querySelectorAll(selector).forEach(check => {
                                if (check.value == v) {
                                  check.click();
                                }
                            });
                        }
                }
            }
        }

        // Paging list
        const pagingListItems = document.querySelectorAll('.pagination-holder ul.pagination li a');
        if (pagingListItems) {
             pagingListItems.forEach(item => {
                  item.addEventListener('click', (e) => {
                      e.preventDefault();
                      const form = document.getElementById('adv-search');
                      form.action = e.currentTarget.href;
                      form.submit();
                  });
             });
        }

        // Sorting
        if (sorting) {
            const sortingItems = sorting.querySelectorAll('ul li button');
            sortingItems.forEach(item => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    const form = document.getElementById('adv-search');
                    form.action = e.currentTarget.dataset.link;
                    form.submit();
                });
            });
        }
    }
    if (paging) {
        const singleSelectPaging = paging.querySelectorAll('.singleselect');
        const items = paging.querySelectorAll('li.dropdown-item button');
        singleSelectPaging.forEach(field => {
            initSingleSelects(field, value => {
                const linkEl = Array.from(items).find(item => item.dataset.value === value);
                if (linkEl) {
                    const form = document.getElementById('adv-search');
                    form.action = linkEl.dataset.link;
                    form.submit();
                }
            });
        });
    }

    function initInputField(field)
    {
        const hasAutocomplete = field.dataset.autocomplete !== undefined,
          dropdown = field.nextElementSibling;

        field.addEventListener('keyup', (e) => {
            sendRequest(hasAutocomplete, field);
        });

        if (!hasAutocomplete) {
            return;
        }

        field.addEventListener('focus', (e) => {
            dropdown.classList.remove('show');
            if (field.value.length > 1) {
                dropdown.classList.add('show');
            }
        });
        field.addEventListener('keyup', (e) => {
            dropdown.classList.remove('show');
            if (field.value.length > 1) {
                dropdown.classList.add('show');
            }
        });
        //check if clicked outside parent element
        document.addEventListener('click', (e) => {
            if (!field.parentElement.contains(e.target)) {
                dropdown.classList.remove('show');
            }
        });
    }

    function initSingleSelects(wrapper, after = false)
    {
        //get all buttons
        const buttons = wrapper.querySelectorAll('.dropdown-item button'),
          dropdownToggleText = wrapper.querySelector('.dropdown-toggle span'),
          toggleTextContent = dropdownToggleText.textContent;

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                //update hidden input value
                wrapper.querySelector('input[type="hidden"]').value = button.value;

                //change dropdown text to selected button text if value is not empty
                dropdownToggleText.textContent = button.value !== '' ? button.textContent : toggleTextContent;

                //send request
                if (after) {
                    after(button.value);
                } else {
                    sendRequest();
                }
            });
        });
    }

    function initMultiSelects(wrapper)
    {
        //get all checkboxes
        const checkboxes = wrapper.querySelectorAll('input[type="checkbox"]:not([id="besand"])'),
          dropdownToggleText = wrapper.querySelector('.dropdown-toggle span'),
          toggleTextContent = dropdownToggleText.textContent;

        const arrayOfValuesFromCheckboxes = [];

        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                //check if checkbox is checked
                if (checkbox.checked) {
                    //add value to array if not already in array
                    if (!arrayOfValuesFromCheckboxes.includes(checkbox.value)) {
                        arrayOfValuesFromCheckboxes.push(checkbox.value);
                    }
                } else {
                    //remove value from array
                    arrayOfValuesFromCheckboxes.splice(arrayOfValuesFromCheckboxes.indexOf(checkbox.value), 1);
                }

                //update hidden input value
                wrapper.querySelector('input[type="hidden"]').value = arrayOfValuesFromCheckboxes.join(',');

                const selectedCount = arrayOfValuesFromCheckboxes.length;
                dropdownToggleText.classList.remove('checked');
                if (selectedCount > 0) {
                    dropdownToggleText.classList.add('checked');
                }
                dropdownToggleText.textContent = selectedCount > 0 ? `${toggleTextContent} (${selectedCount})` :  toggleTextContent;

                //send request
                sendRequest();
            });
        });
    }

    function sendRequest(hasAutocomplete = false, field = null)
    {
        submitBtn.disabled = true;
        const formData = new FormData(document.querySelector('#adv-search'));

        if (hasAutocomplete) {
            formData.append('autocomplete', field.dataset.autocomplete);
        }

        const url = '/search.json';
        fetch(url, {
            method: 'POST',
            body: formData
        })
          .then(response => response.json())
          .then(data => {
            submitBtn.disabled = false;
            resultCount.value = `${data.count} ${btnCountText}`;

            if (hasAutocomplete) {
                showAutocompleteResults(data.autocomplete, field);
            }
        });
    }

    function showAutocompleteResults(results, field)
    {
        const dropdown = field.nextElementSibling;

        dropdown.innerHTML = '';

        if (results.length === 0) {
            dropdown.appendChild(noResultDOMCopy);
            //add event listener to reset form on click
            dropdown.querySelector('.no-result').addEventListener('click', () => {
                field.value = '';
                dropdown.innerHTML = '';
                sendRequest()
                field.blur();
            });
            return
        }

        results.forEach(result => {
            const li = document.createElement('li'),
              button = document.createElement('button');
            button.setAttribute('type', 'button');
            button.textContent = result;
            button.addEventListener('click', () => {
                field.value = result;
                dropdown.classList.remove('show');
            });
            li.classList.add('dropdown-item');
            li.appendChild(button);
            dropdown.appendChild(li);
        });
    }
}
